(function() {
  'use strict';
  
  angular
    .module('app.myPolls')
    .config(statesConfig);
      
    statesConfig.$inject = ['$stateProvider'];
    
    function statesConfig($stateProvider) {
      $stateProvider
        .state('shell.myPolls', {
          url: '/my-polls',
          template: '<ui-view />',
          controller: 'MyPollsController as vm',
          redirectTo: 'shell.myPolls.upcoming'
        })
        .state('shell.myPolls.upcoming', {
          url: '/upcoming',
          templateUrl: 'app/my-polls/upcoming/upcoming.html',
          controller: 'UpcomingController as vm'
        })
        .state('shell.myPolls.collections', {
          url: '/collection',
          template: '<ui-view/>'
        })
        .state('shell.myPolls.collections.viewCollection', {
          url: '/:collectionId',
          templateUrl: 'app/my-polls/collections/view-collection.html',
          controller: 'ViewCollectionController as vm'
        })
        .state('shell.myPolls.collections.editPolls', {
          params: { jumpToAddPoll: false },
          url: '/:collectionId/:groupId/edit',
          templateUrl: 'app/my-polls/collections/edit-polls.html',
          controller: 'EditPollsController as vm'
        })
        .state('shell.myPolls.collections.leaderboard', {
          url: '/:collectionId/leaderboard',
          templateUrl: 'app/my-polls/collections/leaderboard.html',
          controller: 'LeaderboardController as vm'
        })
        .state('shell.myPolls.archive', {
          url: '/archive',
          templateUrl: 'app/my-polls/archive/archive.html',
          controller: 'ArchiveController as vm'
        })
        .state('shell.myPolls.trash', {
          url: '/trash',
          templateUrl: 'app/my-polls/trash/trash.html',
          controller: 'TrashController as vm'
        })
        .state('shell.myPolls.settings', {
          url: '/settings',
          templateUrl: 'app/my-polls/settings/settings.html',
          controller: 'SettingsController as vm'
        }) 
        .state('shell.myPolls.userGuide', {
          url: '/user-guide',
          templateUrl: 'app/my-polls/user-guide/user-guide.html',
          controller: 'UserGuideController as vm'
        })
        .state('shell.myPolls.communityNews', {
          url: '/community-news',
          templateUrl: 'app/my-polls/community-news/community-news.html',
          controller: 'CommunityNewsController as vm'
        })
      }
  
})();